import { Tab, Tabs, styled } from "@mui/material";

import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function TradeWalletTabs() {
  const tradeForm = useSelector((state) => state.trade.tradeForm?.data);

  const [searchParams, setSearchParams] = useSearchParams();
  const walletTypeId = +searchParams.get("walletTypeId") || 0;

  const handleChange = (_, value) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      page: 1,
      walletTypeId: value,
    });
  };

  return (
    <TabsStyle value={walletTypeId} onChange={handleChange}>
      {tradeForm?.lisWalletType?.map((tab) => (
        <Tab value={tab.id} label={tab.name} key={tab.id} />
      ))}
    </TabsStyle>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));

export default TradeWalletTabs;
